export const locationCenterReplacements = [
  "AL Demo Kitchen",
  "Art and Exercise Terrace",
  "Bistro",
  "Calyx Lobby",
  "Craft Room Patio",
  "Craft Room",
  "Demo Kitchen",
  "Demonstration Kitchen",
  "Dining Room Terrace",
  "Dining Room",
  "Fireplace Patio",
  "Front Entrance",
  "Front Lobby",
  "Front Porch",
  "Game Room",
  "Grounds",
  "Lobby",
  "Lounge",
  "Main Courtyard",
  "Main Courtyard",
  "Main Dining Patio",
  "Main Dining Room Patio",
  "Main Dining Room",
  "Meet in Lobby",
  "Outing: Lobby",
  "Outing",
  "Patio",
  "Private Dining Room",
  "Reception",
];

export const legend = {
  "a-wing": {
    rooms: [
      "Media Game Room",
      "Media & Game Room",
      "Art Studio",
      "Exercise Studio",
      "Game Space",
      "Theater",
    ],
    label: "A Wing",
  },
  "b-wing": {
    rooms: ["B Wing Theater", "Game Space", "B Wing Dining"],
    label: "B Wing",
  },
  "c-wing": {
    rooms: [
      // "Activity Room",
      "C Hall Activities",
      "C Hall Living Room",
      "C Hall Patio",
      "C Wing Activities",
      "C Wing Dining",
      "C Wing Living Room",
      "C Wing Patio",
      "C Wing Patio",
      "Courtyard",
      "Creative Space",
      "Dining Room",
      "Game Space",
      "Living Room",
      "MC Courtyard",
      "MC Garden Courtyard",
      "Meditation Room",
      "Sun Room",
      "Terrace",
      "Theater",
    ],
    label: "C Wing",
  },
  "d-wing": {
    rooms: [
      "Activity Room",
      "Blue Fountain Patio",
      "Great Room",
      "Great Room Patio",
      "D Hall Craft Room",
      "Beauty Salon",
      "D Wing Porch",
    ],
    label: "D Wing",
  },
  center: {
    rooms: locationCenterReplacements,
    label: "the Heart of Our Community",
  },
  outdoor: {
    rooms: ["Front Terrace", "Main Courtyard", "Vegetable Garden"],
    label: "Outdoor Spaces",
  },
};

export const wakefieldLegend = {
  "a-wing": {
    rooms: [
      "Theater",
      "Art Studio",
      "Activity Room",
      "Beauty Salon",
      "Exercise Studio",
      "Game Space",
      "Spa",
      "Exercise Terrace",
    ],
    label: "A Wing",
  },
  "b-wing": {
    rooms: [],
    label: "B Wing",
  },
  "c-wing": {
    rooms: [
      "Creative Space",
      "Terrace",
      "Gathering Room",
      "Meditation Room",
      "Dining Room",
      "MC Dining Room",
      "Sunroom",
      "Potting Studio",
      "Screen Porch",
      "Reception",
    ],
    label: "C Wing",
  },
  "d-wing": {
    rooms: [],
    label: "D Wing",
  },
  center: {
    rooms: locationCenterReplacements,
    label: "the Heart of Our Community",
  },
  outdoor: {
    rooms: [
      "Front Terrace",
      "Main Dining Courtyard",
      "Exercise Patio",
      "Garden Patio",
      "Bocce Court",
      "Main Courtyard",
      "Vegetable Garden",
      "Walking Path",
      "Gardening Terrace",
    ],
    label: "Outdoor Spaces",
  },
};

export default function getLocationSlug(locationName, community = "") {
  let communityLegend = legend;

  if (community === "wakefield" || community === "apex") {
    communityLegend = wakefieldLegend;
  }

  let locationSlug = locationName || "";

  if (locationCenterReplacements.includes(locationSlug)) {
    locationSlug = "center";
  }

  if (locationSlug.includes("A Wing")) {
    locationSlug = "a-wing";
  } else if (locationSlug.includes("B Wing")) {
    locationSlug = "b-wing";
  } else if (locationSlug.includes("C Wing")) {
    locationSlug = "c-wing";
  }

  for (const key in communityLegend) {
    if (communityLegend[key].rooms.includes(locationName?.trim())) {
      locationSlug = key;
      break;
    }
  }

  return locationSlug;
}
